import { Injectable, inject } from '@angular/core';
import { DestroyableComponent } from '@core/destroyable';
import { HttpClient } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { FileAttachment } from '@models/file-attachment';

@Injectable()
export class AttachmentDownloadService extends DestroyableComponent {
	private http = inject(HttpClient);


	GetFile(fileGuid: string): Promise<FileAttachment> {
		return new Promise<FileAttachment>((resolve, reject) => {
			this.http
				.get<FileAttachment>(`incident-flow-attachments/${fileGuid}`)
				.pipe(takeUntil(this.ngUnsubscribe))
				.subscribe(
					(result) => resolve(result),
					(error) => reject(error)
				);
		});
	}
}
